var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticStyle: { display: "inline-table" } },
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        title: _vm.$t(
                          "apeironGwApp.institucionesF1Snp.mensajes.agregarInstitucionTooltip"
                        ),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.mostrarModal()
                        },
                      },
                    },
                    [
                      _c("strong", [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.institucionesF1Snp.acciones.nueva"
                              )
                            ),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-iconstack",
                        { attrs: { "font-scale": "1.2" } },
                        [
                          _c("b-icon", {
                            attrs: {
                              stacked: "",
                              icon: "house-door",
                              scale: "0.8",
                              "shift-v": "-2",
                              variant: "primary",
                            },
                          }),
                          _vm._v(" "),
                          _c("b-icon", {
                            attrs: {
                              stacked: "",
                              icon: "plus",
                              scale: "0.7",
                              "shift-h": "6",
                              "shift-v": "2",
                              variant: "success",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-modal",
                    {
                      attrs: { id: "modal-instituciones-snp", size: "xl" },
                      scopedSlots: _vm._u([
                        {
                          key: "modal-title",
                          fn: function () {
                            return [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.institucionesF1Snp.mensajes.tituloRegistrarInstitucion"
                                    )
                                  ),
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "modal-footer",
                          fn: function () {
                            return [
                              !!_vm.institucionSeleccionada.claveInstitucion
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deseleccionarInstitucion()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.institucionesF1Snp.acciones.reset"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !!_vm.institucionSeleccionada.claveInstitucion
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.agregarInstitucion()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.institucionesF1Snp.acciones.guardar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.modalVisible = false
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.institucionesSnp.acciones.cerrar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.modalVisible,
                        callback: function ($$v) {
                          _vm.modalVisible = $$v
                        },
                        expression: "modalVisible",
                      },
                    },
                    [
                      _vm._v(" "),
                      !_vm.institucionSeleccionada.claveInstitucion
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c("buscador-instituciones-snp", {
                                    attrs: { mostrarInfo: false },
                                    on: {
                                      selected: function ($event) {
                                        return _vm.seleccionarInstitucion(
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !!_vm.institucionSeleccionada.claveInstitucion
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _c(
                                          "h6",
                                          { staticClass: "fnt-color-1255" },
                                          [
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.$t(
                                                    "apeironGwApp.institucionesF1Snp.mensajes.institucionSeleccionada"
                                                  )
                                                ),
                                              },
                                            }),
                                            _vm._v(":\n                  "),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.noDeRegistro"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm
                                                        .institucionSeleccionada
                                                        .reniecyt
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.sector"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm
                                                        .institucionSeleccionada
                                                        .sector
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.rfc"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm
                                                        .institucionSeleccionada
                                                        .rfc
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.claveInstitucion"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm
                                                        .institucionSeleccionada
                                                        .claveInstitucion
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.institucion"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  staticClass: "fnt-color-7421",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm
                                                        .institucionSeleccionada
                                                        .nombreInstitucion
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.pais"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm
                                                        .institucionSeleccionada
                                                        .pais
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.entidadFederativa"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm
                                                        .institucionSeleccionada
                                                        .entidadFederativa
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.municipio"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm
                                                        .institucionSeleccionada
                                                        .municipio
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("b-col"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _c(
                                          "h6",
                                          { staticClass: "fnt-color-1255" },
                                          [
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.$t(
                                                    "apeironGwApp.institucionesF1Snp.mensajes.sedeSeleccionada"
                                                  )
                                                ),
                                              },
                                            }),
                                            _vm._v(":"),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.claveSede"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.sedeSeleccionada
                                                        .claveSede
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.sede"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.sedeSeleccionada.sede
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.claveDependencia"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.sedeSeleccionada
                                                        .claveDependencia
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.dependencia"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  staticClass: "fnt-color-7421",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.sedeSeleccionada
                                                        .nombreDependencia
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.pais"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.sedeSeleccionada.pais
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.entidadFederativa"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.sedeSeleccionada
                                                        .entidadFederativa
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.campos.municipio"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(":"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.sedeSeleccionada
                                                        .municipio
                                                    ),
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("b-col"),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }